<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <v-sheet
          class="mo-panel neo-surface elevation-3 rounded-xl mx-auto"
          max-width="820"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-btn icon small class="white--text mr-1" @click="goBack">
              <v-icon color="white" small>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left color="white" class="mr-2">mdi-factory</v-icon>
              DETAIL FORM PALLET
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              class="white--text"
              :disabled="loading"
              @click="refreshData"
            >
              <v-icon color="white" small :class="{ spin: loading }"
                >mdi-refresh</v-icon
              >
            </v-btn>
          </v-toolbar>
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6 neo-surface">
              <v-skeleton-loader v-if="loading" type="article, actions" />
              <div v-else>
                <v-row dense>
                  <v-col cols="12">
                    <div class="mo-header value emphasis-1">
                      {{ detail.company_name }}
                    </div>
                  </v-col>
                  <v-col cols="7">
                    <div class="label">NO PALET</div>
                    <div class="value strong">{{ detail.passed_no }}</div>
                  </v-col>
                  <v-col cols="5">
                    <div class="label">NO LOT</div>
                    <div class="value strong">{{ detail.lot_no }}</div>
                  </v-col>
                  <v-col cols="7">
                    <div class="label">KODE PRODUK</div>
                    <div class="value">{{ detail.product_code }}</div>
                  </v-col>
                  <v-col cols="5">
                    <div class="label">NAMA PRODUK</div>
                    <div class="value uppercase">{{ detail.product_name }}</div>
                  </v-col>
                  <v-col cols="7">
                    <div class="label">TGL PRODUKSI</div>
                    <div class="value">
                      {{ formatDateTime(detail.date_planned_start) }}
                    </div>
                  </v-col>
                  <v-col cols="5">
                    <div class="label">SHIFT</div>
                    <div class="value">{{ detail.shift_name }}</div>
                  </v-col>
                  <v-col cols="7">
                    <div class="label">MESIN</div>
                    <div class="value uppercase">{{ detail.machine_name }}</div>
                  </v-col>
                  <v-col cols="5">
                    <div class="label">JUMLAH MUAT</div>
                    <div class="value">
                      {{ formatNumber(detail.qty_production) }} DUS
                    </div>
                  </v-col>
                  <v-col cols="7">
                    <div class="label">SISA MUATAN</div>
                    <div class="value">
                      {{ formatNumber(detail.qty_remain) }}
                    </div>
                  </v-col>
                </v-row>
                <v-row dense class="mt-10">
                  <v-col cols="12" md="6">
                    <v-btn block class="neo-btn" @click="dialogScanMemo = true"
                      >PROSES MUAT</v-btn
                    >
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-btn block class="neo-btn" @click="cekMutasi"
                      >CEK MUTASI</v-btn
                    >
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-btn block class="neo-btn mt-5" @click="gotoDashboard"
                      >KEMBALI KE AWAL</v-btn
                    >
                  </v-col>
                </v-row>
                <v-slide-y-transition>
                  <div v-if="false" class="mt-3">
                    <v-row dense>
                      <v-col cols="12" md="8">
                        <v-text-field
                          class="neo-input"
                          v-model="memoNo"
                          label="Scan/Tempel Nomor Memo"
                          prepend-inner-icon="mdi-numeric"
                          append-outer-icon="mdi-qrcode-scan"
                          @click:append-outer="dialogScanMemo = true"
                          clearable
                          outlined
                          dense
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        class="d-flex align-center justify-end"
                      >
                        <v-btn class="neo-btn" disabled>
                          <v-icon left>mdi-magnify</v-icon>
                          Cari
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-progress-linear
                          v-if="searchingMemo"
                          indeterminate
                          color="primary"
                          height="4"
                          rounded
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-slide-y-transition>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <production-scanner
      v-model="dialogScanMemo"
      title="Scan Memo Muat"
      input-label="Scan/Tempel Nomor Memo"
      :action-label="'Scan'"
      :auto-close-on-scan="true"
      :auto-emit-on-scan="true"
      @scanned="goToMemoDetail"
    />
  </v-container>
</template>

<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
import { mapMutations, mapGetters } from 'vuex'

const createEmptyDetail = () => ({
  passed_no: '-',
  lot_no: '-',
  product_code: '-',
  product_name: '-',
  company_name: '-',
  qty_production: 0,
  qty_remain: 0,
  machine_name: '-',
  shift_name: '-',
  date_planned_start: null
})

export default {
  name: 'SpreadPalletDetail',
  components: {
    ProductionScanner: () =>
      import('../../../home/components/ProductionScanner.vue')
  },
  data() {
    return {
      passedApi: buildType.apiURL('passed'),
      loading: true,
      detail: createEmptyDetail(),
      memoNo: '',
      dialogScanMemo: false,
      searchingMemo: false
    }
  },
  computed: {
    ...mapGetters(['getPassetDetail'])
  },
  methods: {
    ...mapMutations(['setMemoDetail', 'setPassetDetail']),
    goBack() {
      if (this.$router) this.$router.back()
    },
    gotoDashboard() {
      this.setMemoDetail(null)
      this.setPassetDetail(null)
      const path = '/manufacture/lot-checker'
      if (this.$route.path !== path) this.$router.push(path)
    },
    cekMutasi() {
      this.$swal &&
        this.$swal.fire('Info', 'Fitur cek mutasi akan dihubungkan.', 'info')
    },
    async goToMemoDetail(code) {
      const memoNo = (code || '').toString().trim()
      if (!memoNo || this.searchingMemo) return

      this.memoNo = memoNo
      this.searchingMemo = true

      const url = `${
        this.passedApi
      }loading_memo/search?memo_no=${encodeURIComponent(memoNo)}`

      try {
        const response = await axios.get(url)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          const memoData = payload.data
          this.setMemoDetail(memoData)
          const memoId =
            memoData.id ||
            (Array.isArray(memoData.items) &&
              memoData.items[0] &&
              memoData.items[0].memo_loading_item_id) ||
            memoData.memo_no

          if (memoId && this.$router) {
            this.$router.push({
              name: 'lotCheckerSpreadMemoDetail',
              query: {
                id: memoNo
              }
            })
            return
          }
        }

        const message =
          (payload && payload.status_msg) || 'Data memo tidak ditemukan'
        this.$swal && this.$swal.fire('Info', message, 'warning')
      } catch (error) {
        console.error('goToMemoDetail error', error)
        this.$swal &&
          this.$swal.fire('Error', 'Gagal mengambil data memo', 'error')
      } finally {
        this.searchingMemo = false
      }
    },
    formatNumber(value) {
      if (value == null || value === '') return '0'
      const parsed = Number(value)
      if (Number.isNaN(parsed)) return String(value)
      try {
        return parsed.toLocaleString('id-ID')
      } catch (err) {
        return String(parsed)
      }
    },
    formatDateTime(value) {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return String(value)
      const pad = (num) => (num < 10 ? `0${num}` : String(num))
      return (
        `${pad(date.getDate())}-${pad(
          date.getMonth() + 1
        )}-${date.getFullYear()}` +
        ` ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
          date.getSeconds()
        )}`
      )
    },
    async fetchPalletDetail() {
      const palletNo =
        (this.$route && this.$route.query && this.$route.query.no) ||
        (this.palletFormNo || '').toString().trim()
      if (!palletNo) {
        this.$swal &&
          this.$swal.fire('Info', 'Nomor pallet tidak tersedia', 'warning')
        this.goBack()
        return
      }

      this.loading = true
      try {
        const payload = this.getPassetDetail
        if (payload && payload != null) {
          const data = payload
          this.detail = {
            passed_no: data.passed_no || palletNo,
            lot_no: data.lot_no || '-',
            product_code: data.product_code || '-',
            product_name: data.product_name || '-',
            company_name: data.company_name || '-',
            qty_production: Number(data.qty_production || 0),
            qty_remain: Number(data.qty_remain || 0),
            machine_name: data.machine_name || '-',
            shift_name: data.shift_name || '-',
            date_planned_start: data.date_planned_start || null
          }
          this.memoNo = data.production_no || this.memoNo
        } else {
          const message = 'Data detail pallet tidak ditemukan'
          this.$swal && this.$swal.fire('Info', message, 'warning')
          this.goBack()
        }
      } catch (error) {
        console.error('fetchPalletDetail error', error)
        this.$swal &&
          this.$swal.fire('Error', 'Gagal mengambil detail pallet', 'error')
        this.goBack()
      } finally {
        this.loading = false
      }
    },
    async fetchPalletDetailFromApi() {
      this.loading = true

      const url = `${this.passedApi}palletorder/detail/${encodeURIComponent(
        this.getPassetDetail.passed_no
      )}`

      try {
        const response = await axios.get(url)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          this.setPassetDetail(payload.data)
          this.fetchPalletDetail()
        } else {
          const message =
            (payload && payload.status_msg) || 'Detail pallet tidak ditemukan'
          this.$swal.fire('Info', message, 'warning')
        }
      } catch (error) {
        this.$swal.fire('Error', 'Gagal mengambil detail pallet', 'error')
      } finally {
        this.loading = false
      }
    },
    refreshData() {
      this.fetchPalletDetailFromApi()
    },
    drawBackground() {
      const canvas = this.$refs.bgCanvas
      if (!canvas) return
      const w = canvas.parentElement.clientWidth
      const h = 220
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)
      const g1 = ctx.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        170
      )
      g1.addColorStop(0, 'rgba(144,202,249,.35)')
      g1.addColorStop(1, 'rgba(144,202,249,0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      ctx.fill()
      const g2 = ctx.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        150
      )
      g2.addColorStop(0, 'rgba(165,214,167,.35)')
      g2.addColorStop(1, 'rgba(165,214,167,0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      ctx.fill()
    }
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
    this.fetchPalletDetail()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-header {
  text-align: center;
  position: relative;
  min-height: 28px;
  padding-top: 2px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
  color: #37474f;
}
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}
.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.label {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 2px;
}
.value {
  color: #263238;
}
.center {
  text-align: center;
}
.value.uppercase {
  text-transform: uppercase;
}
.value.strong {
  font-weight: 700;
}
.value.emphasis-1 {
  font-size: 1.25rem;
  font-weight: 700;
}
.value.emphasis-2 {
  font-size: 1.15rem;
  font-weight: 600;
}
.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 10px 16px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
</style>
